import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\CreateSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/CreateSupplierOrderController.php
* @route '/api/supplier-order'
*/
const CreateSupplierOrderController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateSupplierOrderController.url(options),
    method: 'post',
})

CreateSupplierOrderController.definition = {
    methods: ["post"],
    url: '/api/supplier-order',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SupplierOrder\CreateSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/CreateSupplierOrderController.php
* @route '/api/supplier-order'
*/
CreateSupplierOrderController.url = (options?: RouteQueryOptions) => {
    return CreateSupplierOrderController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\CreateSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/CreateSupplierOrderController.php
* @route '/api/supplier-order'
*/
CreateSupplierOrderController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateSupplierOrderController.url(options),
    method: 'post',
})

export default CreateSupplierOrderController